import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { SseNotificationService } from './core/services/sse-notification.service';

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cashier';

  constructor(
    private router: Router,
    private auth: AuthService,
    private sse: SseNotificationService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) return;
      window.scrollTo(0, 0);
    });

    // Si déjà connecté au démarrage (token persisté), démarrer SSE
    if (this.auth.estConnecte()) {
      this.sse.demarrer();
    }

    // Démarrer/arrêter SSE selon l'état de connexion
    this.auth.connexionStatusObservable.subscribe((connecte) => {
      if (connecte) {
        this.sse.demarrer();
      } else {
        this.sse.arreter();
      }
    });
  }

  isSideNavCollapsed = false;
  screenWidth = 0;

  onToggleSideNav(data: SideNavToggle): void {
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
  }
}
